import { IGetProfessionalProfileParams } from '../../types/IGetProfessionalProfileParams';

export const factoryGetProfessionalProfileKey = ({
  professionalId,
  officeId,
  jobProfession,
}: IGetProfessionalProfileParams) =>
  ['professional-profile', professionalId, officeId, jobProfession] as const;
